<template>
  <div>
    <Head title="Profissional de saúde" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Profissional de saúde</h1>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="professionals/list"
        no-data-label="Nenhum profissional de saúde cadastrado"
        no-result-label="Nenhum profissional de saúde encontrado"
      >
        <template #table.cell.content.professional_status="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>
        <template #grid.content.body.professional_status="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>

        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>

        <template #after.reload-button>
          <button class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Profissional</span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit ref="modalEdit" title="Profissional" url="professionals" @submitForm="reloadTable" :item="{user: {}, group: null, specialty: null, errors: {user: {}}}">
      <template #form="{item}">
        <text-input v-model="item.user.name" :error="item.errors[`user.name`]" class="lg:pr-6 w-full lg:w-1/2" label="Nome" />
        <mask-input v-model="item.user.cpf" mask="###.###.###-##" :error="item.errors[`user.cpf`]" class="mt-6 lg:mt-0 w-full lg:w-1/2" label="CPF" />
        <text-input v-model="item.user.email" :error="item.errors[`user.email`]" class="mt-6 lg:pr-6 w-full lg:w-1/2" label="E-mail" />
        <password-input v-model="item.user.password" :error="item.errors[`user.password`]" class="mt-6 w-full lg:w-1/2" label="Senha" />
        <vue-select-input v-model="item.specialty" :options="specialties" :error="item.errors[`specialty.id`]" class="mt-6 lg:pr-6 w-full lg:w-1/2" label="Especialidade" text="nenhuma especialidade encontrada" />
        <vue-select-input v-model="item.group" :options="groups" :error="item.errors[`group.id`]" class="mt-6 w-full lg:w-1/2" label="Grupo" text="nenhum grupo encontrado" />
        <select-input v-model="item.class_entity" :error="item.errors.class_entity" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Conselho profissional">
          <option :value="null" />
          <option v-for="(value, name, index) in class_entity_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <text-input v-model="item.class_number" :error="item.errors.class_number" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Número do órgão" />
        <select-input v-model="item.uf" :error="item.errors.uf" class="mt-6 w-full lg:w-1/3" label="UF">
          <option :value="null" />
          <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <switch-input v-model="item.chat" class="w-full mt-6 lg:w-1/4" label="Permissão do chat" labelChecked="Permitido" labelUnchecked="Não permitido" />
        <switch-input v-model="item.status" class="w-full mt-6 lg:w-1/4" label="Situação" labelChecked="Ativo" labelUnchecked="Inativo" />
      </template>
    </modal-edit>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import DataTable from '@/Shared/DataTable'
import SwitchInput from '@/Shared/SwitchInput'
import TextInput from '@/Shared/TextInput'
import PasswordInput from '@/Shared/PasswordInput'
import SelectInput from '@/Shared/SelectInput'
import MaskInput from '@/Shared/MaskInput'
import VueSelectInput from '@/Shared/VueSelectInput'

export default {
  props: {
    states_options: Object,
    class_entity_options: Object,
  },
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    SwitchInput,
    TextInput,
    PasswordInput,
    SelectInput,
    MaskInput,
    VueSelectInput,
  },
  layout: Layout,
  mounted() {
    this.loadOptions();
  },
  setup() {

  },
  data() {
    return {
      specialties: [],
      groups: [],
      loadTable: true,
      columns: [
        {
          uniqid: 'professional_name',
          label: 'Nome',
          field: 'users.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.name}`,
        },
        {
          uniqid: 'professional_cpf',
          label: 'CPF',
          field: 'users.cpf',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.cpf}`,
        },
        {
          uniqid: 'professional_email',
          label: 'E-mail',
          field: 'users.email',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.email}`,
        },
        {
          uniqid: 'professional_specialty',
          label: 'Especialidade',
          field: 'specialties.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.specialty ? row.specialty.name : ''
        },
        {
          uniqid: 'professional_class_number',
          label: 'Registro',
          field: 'class_number',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.class_number ? row.class_number : ''
        },
        {
          uniqid: 'professional_status',
          label: 'Situação',
          field: 'status',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'professional_group',
          label: 'Grupo',
          field: 'groups.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.group ? row.group.name : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/professionals/update-status", {id: item.id, status: item.status});
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/professionals/${item.id}`, `Deseja realmente excluir o profissional de saúde ${item.user.name}?`);
    },
    openModalEdit(i) {
      let item = {
        id: i.id,
        class_entity: i.class_entity,
        class_number: i.class_number,
        uf: i.uf,
        chat: i.chat ?? true,
        status: i.status ?? true,
        user: {},
        group: null,
        specialty: null,
      }
      if(i.user) {
        item.user = {
          id: i.user.id,
          name: i.user.name,
          email: i.user.email,
          cpf: i.user.cpf,
        }
      }
      if(i.group) {
        item.group = {
          id: i.group.id,
          name: i.group.name,
        }
      }
      if(i.specialty) {
        item.specialty = {
          id: i.specialty.id,
          name: i.specialty.name,
        }
      }
      this.$refs.modalEdit.openModalEdit(item);
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    async loadOptions() {
      await fetch(
        `professionals/get-options`
      ).then(res => {
        res.json().then(json => {
          this.specialties = json.specialties;
          this.groups = json.groups;
        });
      });
    },
  },
}
</script>